import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DealerProfile } from '@app/domain/model/dealer-profile';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { confirmations, httpCustomErrors } from '@app/shared/app-settings';
import { ToastrService } from 'ngx-toastr';
import { DealerResetPasswordComponent } from '@app/feature/dealer/authentication/dealer-reset-password/dealer-reset-password.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Component({
  templateUrl: './dealer-profile.component.html',
  styleUrls: ['./dealer-profile.component.scss']
})
export class DealerProfileComponent implements OnInit, OnDestroy {

  profile: DealerProfile;
  loading = false;
  private routeSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private readonly toastrService: ToastrService,
    private readonly dealerAuthenticationService: AuthenticationService,
    private readonly modalService: NgbModal
  ) {
  }


  ngOnInit() {
    this.routeSubscription = this.route.data.subscribe(({ profile }) => {
      this.profile = profile;
    });
  }
  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }

  resetPassword() {
    this.loading = true;

    this.dealerAuthenticationService.resetMyPassword().subscribe(()=>{
      this.loading = false;
      const modal = this.modalService.open(DealerResetPasswordComponent, { backdrop: 'static', keyboard: false });
      modal.componentInstance.resetComplete = true;
      modal.componentInstance.resetSuccess = true;
      modal.componentInstance.resetCofirmationTitle = confirmations.passwordReset.title;
      modal.componentInstance.resetCofirmationMessage = confirmations.passwordReset.description;
    },
    () => {
      this.loading = false;
      const modal = this.modalService.open(DealerResetPasswordComponent, { backdrop: 'static', keyboard: false });
      modal.componentInstance.resetComplete = true;
      modal.componentInstance.resetSuccess = false;
      modal.componentInstance.resetCofirmationTitle = httpCustomErrors.errorTitle;
      modal.componentInstance.resetCofirmationMessage = httpCustomErrors.passwordReset;
    });
  }

}
